import { render } from "./ExcludedProducts.vue?vue&type=template&id=ce5d3346&scoped=true"
import script from "./ExcludedProducts.vue?vue&type=script&lang=js"
export * from "./ExcludedProducts.vue?vue&type=script&lang=js"

import "./ExcludedProducts.vue?vue&type=style&index=0&id=ce5d3346&scoped=true&lang=scss"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce5d3346"]])

export default __exports__